var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pcTabs"},_vm._l((_vm.tabsName),function(item,index){return _c('div',{key:item,class:index == _vm.activeIndex ? 'activeTab' : 'normalTab',style:(`width:${94/_vm.tabsName.length}%`),on:{"click":function($event){return _vm.active(index)}}},[_vm._v(_vm._s(item))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }